import { render, staticRenderFns } from "./issue_board_filtered_search.vue?vue&type=template&id=8f14edfa&"
import script from "./issue_board_filtered_search.vue?vue&type=script&lang=js&"
export * from "./issue_board_filtered_search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports